
import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { AlertController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import * as io from 'socket.io-client';
import * as $ from 'jquery'
import 'rxjs/add/operator/map';
var date;
var aa = new Date();
function getPaddedComp(comp) {
  return ((parseInt(comp) < 10) ? ('0' + comp) : comp)
}
date = aa.getFullYear() + '-' + (getPaddedComp(aa.getMonth() + 1)) + '-' + getPaddedComp(aa.getDate());

// var socketurl = "https://godabao.valiantsystems.com";


@Injectable()
export class DbservicesProvider {
  headers;
  options;

  public baseResource;
  public baseMethod;
  public baseUrl;
  // public baseResource = "https://godabao.valiantsystems.com/api/resource/";
  // public baseMethod = "https://godabao.valiantsystems.com/api/method/";
  // public baseUrl = "https://godabao.valiantsystems.com";

  public adminemail = localStorage.AdminId;
  public adminname = localStorage.adminName;
  public restaurant_name =localStorage.restaurant_name;

  constructor(public alertCtrl: AlertController, public http: Http) {
    // console.log('Hello DbservicesProvider Provider');
    // this.headers = new Headers({ 'withCredentials': 'true' });
    // // if (this.platform.is('core')) 
    //    if(localStorage.api_key != undefined)
    //      this.headers = new Headers({ 'Authorization': 'token '+localStorage.api_key+":"+localStorage.api_secret });
  }
  alert(condition) {
    let alert = this.alertCtrl.create({
      title: 'Alert',
      subTitle: condition,
      buttons: [
        {
          text: 'OK',
          handler: () => {
            let alertTransition = alert.dismiss();
            alertTransition.then(() => {
            });
            return false;
          }
        }]
    });
    alert.present();
  }

  get_version() {
    let endpoint = 'https://build-version.firebaseio.com/godabaoadmin.json';
    return this.get(endpoint);
  }

  dashboard_info(data) {
    var endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_vendor_dashboard';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  get_url() {
    let endpoint = 'https://build-version.firebaseio.com/Godabao_stage_url.json';
    // let endpoint = 'https://build-version.firebaseio.com/Godabaourl.json';
    return this.get(endpoint);
  }

  get(endpoint: string) {
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.get(endpoint, this.options).map(res => res.json());
  }

  // postmethod(endpoint: string,data) {
  //   // if (this.platform.is('core')) 
  //      if(localStorage.api_key != undefined)
  //        this.headers = new Headers({ 'Authorization': 'token '+localStorage.api_key+":"+localStorage.api_secret });
  //   this.options = new RequestOptions({ headers: this.headers });
  //   return this.http.post(endpoint, data, this.options).map(res => res.json());
  // }

  getLogin(accountInfo: any): any {
    var data = {
      usr: accountInfo.username,
      pwd: accountInfo.password
    }
    let endpoint = 'login'
    return $.post(this.baseMethod + endpoint, data, this.options)
  }

  update_order(data): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.update_status';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  stauts_based_admin_orderlist(data): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.stauts_based_admin_orderlist'
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  order_list(data): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.admin_order_list'
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  get_restaurant_preparation_time(data): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.get_restaurant_preparation_time';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

update_restaurant_time(data): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.api.update_restaurant_time';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  order_count(data): any {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_orders_count'
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  admin_Info(email): any {
    var data = {
      user: email,
      role: "Vendor",
      doctype: "Shop User"
    }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_manager_info';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }
  get_pending_bookings(data) {
    let endpoint = 'table_reservation.table_reservation.api.get_pending_bookings'
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  get_approved_bookings(data) {
    let endpoint = 'table_reservation.table_reservation.api.get_approved_bookings'
    return $.post(this.baseMethod + endpoint, data, this.options);
  }
  update_booking(data) {
    let endpoint = 'reservations.reservations.api.update_booking_status'
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  sales_report(data):any{
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.sales_report';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }
  get_restaturantdetail(id) {
    var data = {
      name: id
    }
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.mobileapi.get_business_detail';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  get_all_category(data): any {
    let endpoint = "ecommerce_business_store.ecommerce_business_store.mobileapi.category_list"
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  update_restaurant_closing(data): any {
    let endpoint = "ecommerce_business_store.ecommerce_business_store.api.update_restaurant_closing"
    return this.http.post(this.baseMethod + endpoint, data, this.options);
    // return $.post(this.baseMethod + endpoint, data, this.options);
  }

  validate_business_opening(data): any {
    let endpoint = "ecommerce_business_store.ecommerce_business_store.api.validate_business_opening"
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  update_availability(data): any {
    var datas={
      data:JSON.stringify(data)
    }
    let endpoint = "ecommerce_business_store.ecommerce_business_store.mobileapi.update_product_availability"
    return $.post(this.baseMethod + endpoint, datas, this.options);
    // return this.http.post(this.baseMethod + endpoint, JSON.stringify(data), this.options);
  }
  update_playerid(data): any {
    // let endpoint = 'Shop Users/' + name;
    let endpoint = "notification.notification.api.update_user_device_id"

    // let endpoint = "ecommerce_business_store.ecommerce_business_store.mobileapi.update_player_id"
    return $.post(this.baseMethod + endpoint, data, this.options);
    // return this.http.put(this.baseResource + endpoint, data, this.options);
  }
  daily_sales_report(data){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.daily_sales_report';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }
  monthly_sales_report(data){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.monthly_sales_report';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }
  yearly_sales_report(data){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.yearly_sales_report';
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  export_excel(args){
    let endpoint = 'frappe.desk.query_report.export_query';
    let headers = new Headers({ 'Authorization': 'token cf174f9e81cda30:97412f06fc7e648' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.baseMethod + endpoint, args, options);
  }

  send_report_via_mail(data){
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.send_report_mail';
    // return this.postmethod(this.baseMethod + endpoint, data);
    return $.post(this.baseMethod + endpoint, data, this.options);
  }

  get_years_list() {
    let endpoint = 'ecommerce_business_store.ecommerce_business_store.reports.get_years';
    return $.post(this.baseMethod + endpoint, {}, this.options);
  }

}
@Injectable()
export class ChatService {
  public socketurl;
  private socket;

  sendMessage(message) {
    this.socket.emit('insert_order', message);
  }

  getMessages() {
    let observable = new Observable(observer => {
      this.socket = io(this.socketurl);
      this.socket.on('order_tracking', (data) => {
        console.log(data)
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    })
    return observable;
  }

}



// WEBPACK FOOTER //
// ./src/providers/dbservices/dbservices.ts